import React from 'react'
import PropTypes from 'prop-types'
import { isProduction } from 'config'

const propTypes = {
  children: PropTypes.node.isRequired,
}

const SHOW_STYLEGUIDE = !isProduction() || process.env.DISPLAY_STYLEGUIDE

function Layout({ children }) {
  if (!SHOW_STYLEGUIDE) return null
  return <div>{children}</div>
}

Layout.propTypes = propTypes

export default Layout
